import { useMsal } from "@azure/msal-react";
import { createBrowserRouter, Navigate } from "react-router-dom";
import LandingScreen from "../screens/LandingScreen/LandingScreen";
import MainScreen from "../screens/MainScreen.tsx/MainScreen";
import ManageScreen from "../screens/ManageScreen/ManageScreen";
import UserManagementScreen from "../screens/UserManagementScreen/UserManagementScreen";
import VerticalManagementScreen from "../screens/VerticalManagementScreen/VerticalManagementScreen";
import React from "react";
import DetailsScreen from "../screens/DetailsScreen/DetailsScreen";
import EditScreen from "../screens/EditScreen/EditScreen";
import { RolePermissions } from "../models/role";
import { useRolePermissionsStore } from "../stores/rolePermissionsStore";

export const router = createBrowserRouter([
  {
    path: "",
    element: <LandingScreen />,
  },
  {
    path: "/",
    element: <LandingScreen />,
  },
  {
    path: "/main",
    element: <GuardedMain />,
  },
  {
    path: "/main/verticals",
    element: <GuardedMain />,
  },
  {
    path: "/main/verticals/:verticalId",
    element: <GuardedMain />,
  },
  {
    path: "/manage",
    element: <GuardedManage />,
  },
  {
    path: "/manage/users",
    element: <GuardedUserManagement />,
  },
  {
    path: "/manage/verticals",
    element: <GuardedVerticalManagement />,
  },
  {
    path: "/details/:videoId/:searchKeyword?",
    element: <GuardedDetails />,
  },
  {
    path: "/edit/:videoId",
    element: <GuardedEdit />,
  },
  {
    path: "*",
    element: <Navigate to="/" replace />,
  },
]);

function GuardedMain() {
  const rolePermissions = useRolePermissionsStore(
    (state: { rolePermissions: RolePermissions | null }) =>
      state.rolePermissions,
  );
  if (rolePermissions === null) {
    return <MissingPermissionsFallback />;
  }
  if (!rolePermissions.video.browse || !rolePermissions.folder.list) {
    return <Navigate to="/" replace />;
  }
  return <MainScreen />;
}

function GuardedManage() {
  const rolePermissions = useRolePermissionsStore(
    (state: { rolePermissions: RolePermissions | null }) =>
      state.rolePermissions,
  );
  if (rolePermissions === null) {
    return <MissingPermissionsFallback />;
  }
  if (!rolePermissions.video.manage) {
    return <Navigate to="/main" replace />;
  }
  return <ManageScreen />;
}

function GuardedUserManagement() {
  const rolePermissions = useRolePermissionsStore(
    (state: { rolePermissions: RolePermissions | null }) =>
      state.rolePermissions,
  );
  if (rolePermissions === null) {
    return <MissingPermissionsFallback />;
  }
  if (!rolePermissions.userManagement) {
    return <Navigate to="/main" replace />;
  }
  return <UserManagementScreen />;
}

function GuardedVerticalManagement() {
  const rolePermissions = useRolePermissionsStore(
    (state: { rolePermissions: RolePermissions | null }) =>
      state.rolePermissions,
  );
  if (rolePermissions === null) {
    return <MissingPermissionsFallback />;
  }
  if (!rolePermissions.verticalManagement) {
    return <Navigate to="/main" replace />;
  }
  return <VerticalManagementScreen />;
}

function GuardedDetails() {
  const rolePermissions = useRolePermissionsStore(
    (state: { rolePermissions: RolePermissions | null }) =>
      state.rolePermissions,
  );
  if (rolePermissions === null) {
    return <MissingPermissionsFallback />;
  }
  if (!rolePermissions.video?.view) {
    return <Navigate to="/main" replace />;
  }
  return <DetailsScreen />;
}

function GuardedEdit() {
  const rolePermissions = useRolePermissionsStore(
    (state: { rolePermissions: RolePermissions | null }) =>
      state.rolePermissions,
  );
  if (rolePermissions === null) {
    return <MissingPermissionsFallback />;
  }
  if (!rolePermissions.video?.edit) {
    return <Navigate to="/main" replace />;
  }
  return <EditScreen />;
}

function MissingPermissionsFallback() {
  const { accounts } = useMsal();

  if (accounts.length === 0) {
    return <Navigate to="/" replace />;
  }

  return null;
}
